<template>
  <div>
    <v-row>
      <v-col class="col-12">
        <v-alert
            v-if="storeInfo.storeStatus === 'OPERATE'"
            text
            dense
        >
          STORE STATUS: {{storeInfo.storeStatus}}
        </v-alert>

        <v-row>
          <v-col cols="6">
            <v-card class="pa-4 rounded h-100 d-flex flex-column justify-center">
              <div class="text-center">
                <p class="font-weight-medium grey--text text--darken-3 text-14 mb-2"># Purchasable NFT</p>
                <p class="grey--text text--darken-1 text-16 text-capitalize mb-0">{{ storeInfo.purchasableNum }}</p>
              </div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card class="pa-4 rounded h-100 d-flex flex-column justify-center">
              <div class="text-center">
                <p class="font-weight-medium grey--text text--darken-3 text-14 mb-2"># Redeemable NFT</p>
                <p class="grey--text text--darken-1 text-16 text-capitalize mb-0">{{ storeInfo.redeemableNum }}</p>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col class="col-12 pt-0">
        <div class="d-flex flex-column h-100 justify-space-between">
          <v-card class="pa-2 h-100 d-flex flex-column justify-center">
            <div class="text-center">
              <p class="font-weight-medium grey--text text--darken-3 text-12 mb-2">Store Address</p>
              <p class="grey--text text--darken-1 mb-0">{{ storeInfo.address }}</p>
            </div>
          </v-card>
          <v-card class="pa-2 h-100 d-flex flex-column justify-center">
            <div class="text-center">
              <p class="font-weight-medium grey--text text--darken-3 text-12 mb-2">Store Treasury</p>
              <p class="grey--text text--darken-1 mb-0">{{ storeInfo.treasury }}</p>
            </div>
          </v-card>
          <v-card class="pa-2 h-100 d-flex flex-column justify-center">
            <div class="text-center">
              <p class="font-weight-medium grey--text text--darken-3 text-12 mb-2">Nft Contract</p>
              <p class="grey--text text--darken-1 mb-0">{{ storeInfo.nftContract }}</p>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div>


</template>

<script>

export default {
  name: "StoreInfo",
  data() {
    return {}
  },
  props: {
    storeInfo: Object
  }
}
</script>

<style scoped>

</style>